import { library, findIconDefinition } from "@fortawesome/fontawesome-svg-core";
import categories from "@fortawesome/fontawesome-pro/metadata/categories.yml";
import icons from "@fortawesome/fontawesome-pro/metadata/icons.yml";
import mapValues from "lodash/mapValues";
import filter from "lodash/filter";
import intersection from "lodash/intersection";

import { fas } from "@fortawesome/pro-solid-svg-icons";

import { faSpinner } from "@fortawesome/pro-light-svg-icons/faSpinner";
import { faTelescope } from "@fortawesome/pro-light-svg-icons/faTelescope";
import { faSlidersH } from "@fortawesome/pro-light-svg-icons/faSlidersH";
import { faPlusCircle } from "@fortawesome/pro-light-svg-icons/faPlusCircle";
import { faSlidersHSquare } from "@fortawesome/pro-light-svg-icons/faSlidersHSquare";
import { faPollH } from "@fortawesome/pro-light-svg-icons/faPollH";
import { faAward } from "@fortawesome/pro-light-svg-icons/faAward";
import { faMapMarked } from "@fortawesome/pro-light-svg-icons/faMapMarked";
import { faAnalytics } from "@fortawesome/pro-light-svg-icons/faAnalytics";
import { faSquare } from "@fortawesome/pro-light-svg-icons/faSquare";
import { faCheckSquare } from "@fortawesome/pro-light-svg-icons/faCheckSquare";
import { faEnvelope } from "@fortawesome/pro-light-svg-icons/faEnvelope";
import { faGlobe } from "@fortawesome/pro-light-svg-icons/faGlobe";
import { faKey as falKey } from "@fortawesome/pro-light-svg-icons/faKey";
import { faAngleDown } from "@fortawesome/pro-light-svg-icons/faAngleDown";
import { faAngleLeft } from "@fortawesome/pro-light-svg-icons/faAngleLeft";
import { faAngleRight } from "@fortawesome/pro-light-svg-icons/faAngleRight";
import { faCheck } from "@fortawesome/pro-light-svg-icons/faCheck";
import { faGlassCheers } from "@fortawesome/pro-light-svg-icons/faGlassCheers";
import { faLink } from "@fortawesome/pro-light-svg-icons/faLink";
import { faSquareInfo } from "@fortawesome/pro-light-svg-icons/faSquareInfo";
import { faTelescope as falTelescope } from "@fortawesome/pro-light-svg-icons/faTelescope";
import { faChevronRight as falFaChevronRight } from "@fortawesome/pro-light-svg-icons/faChevronRight";
import { faGrin as falGrin } from "@fortawesome/pro-light-svg-icons/faGrin";
import { faLeaf } from "@fortawesome/pro-light-svg-icons/faLeaf";
import { faHamburger } from "@fortawesome/pro-light-svg-icons/faHamburger";
import { faHeart } from "@fortawesome/pro-light-svg-icons/faHeart";
import { faFutbol } from "@fortawesome/pro-light-svg-icons/faFutbol";
import { faPlane } from "@fortawesome/pro-light-svg-icons/faPlane";
import { faLightbulb } from "@fortawesome/pro-light-svg-icons/faLightbulb";
import { faSmile } from "@fortawesome/pro-light-svg-icons/faSmile";
import { faBold } from "@fortawesome/pro-light-svg-icons/faBold";
import { faItalic } from "@fortawesome/pro-light-svg-icons/faItalic";
import { faQuoteLeft } from "@fortawesome/pro-light-svg-icons/faQuoteLeft";
import { faTimes as falTimes } from "@fortawesome/pro-light-svg-icons/faTimes";
import { faEyeSlash } from "@fortawesome/pro-light-svg-icons/faEyeSlash";
import { faSearch as falSearch } from "@fortawesome/pro-light-svg-icons/faSearch";
import { faTimesCircle } from "@fortawesome/pro-light-svg-icons/faTimesCircle";
import { faUserEdit } from "@fortawesome/pro-light-svg-icons/faUserEdit";
import { faSpinner as falSpinner } from "@fortawesome/pro-light-svg-icons/faSpinner";
import { faFileImage } from "@fortawesome/pro-light-svg-icons/faFileImage";
import { faFilePdf } from "@fortawesome/pro-light-svg-icons/faFilePdf";
import { faChartPie } from "@fortawesome/pro-light-svg-icons/faChartPie";
import { faFlagAlt } from "@fortawesome/pro-light-svg-icons/faFlagAlt";
import { faChartColumn } from "@fortawesome/pro-light-svg-icons/faChartColumn";

import { faTable } from "@fortawesome/pro-regular-svg-icons/faTable";
import { faBullseyePointer } from "@fortawesome/pro-regular-svg-icons/faBullseyePointer";
import { faChartScatter } from "@fortawesome/pro-regular-svg-icons/faChartScatter";
import { faThLarge } from "@fortawesome/pro-regular-svg-icons/faThLarge";
import { faDraftingCompass } from "@fortawesome/pro-regular-svg-icons/faDraftingCompass";
import { faPaperPlane } from "@fortawesome/pro-regular-svg-icons/faPaperPlane";
import { faSync } from "@fortawesome/pro-regular-svg-icons/faSync";
import { faArrowFromBottom } from "@fortawesome/pro-regular-svg-icons/faArrowFromBottom";
import { faPlus } from "@fortawesome/pro-regular-svg-icons/faPlus";
import { faTimes } from "@fortawesome/pro-regular-svg-icons/faTimes";
import { faPercent } from "@fortawesome/pro-regular-svg-icons/faPercent";
import { faPencilAlt } from "@fortawesome/pro-regular-svg-icons/faPencilAlt";
import { faPencil } from "@fortawesome/pro-regular-svg-icons/faPencil";
import { faTint } from "@fortawesome/pro-regular-svg-icons/faTint";
import { faPlug } from "@fortawesome/pro-regular-svg-icons/faPlug";
import { faTrashAlt } from "@fortawesome/pro-regular-svg-icons/faTrashAlt";
import { faExternalLinkAlt } from "@fortawesome/pro-regular-svg-icons/faExternalLinkAlt";
import { faChartBar } from "@fortawesome/pro-regular-svg-icons/faChartBar";
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons/faInfoCircle";
import { faHashtag } from "@fortawesome/pro-regular-svg-icons/faHashtag";
import { faDollarSign } from "@fortawesome/pro-regular-svg-icons/faDollarSign";
import { faSortAlt } from "@fortawesome/pro-regular-svg-icons/faSortAlt";
import { faCode } from "@fortawesome/pro-regular-svg-icons/faCode";
import { faLongArrowUp } from "@fortawesome/pro-regular-svg-icons/faLongArrowUp";
import { faLongArrowDown } from "@fortawesome/pro-regular-svg-icons/faLongArrowDown";
import { faLongArrowLeft } from "@fortawesome/pro-regular-svg-icons/faLongArrowLeft";
import { faLongArrowRight } from "@fortawesome/pro-regular-svg-icons/faLongArrowRight";
import { faArrowsV } from "@fortawesome/pro-regular-svg-icons/faArrowsV";
import { faArrowsH } from "@fortawesome/pro-regular-svg-icons/faArrowsH";
import { faExclamationTriangle } from "@fortawesome/pro-regular-svg-icons/faExclamationTriangle";
import { faExclamationCircle } from "@fortawesome/pro-regular-svg-icons/faExclamationCircle";
import { faCopy } from "@fortawesome/pro-regular-svg-icons/faCopy";
import { faClone } from "@fortawesome/pro-regular-svg-icons/faClone";
import { faEllipsisH } from "@fortawesome/pro-regular-svg-icons/faEllipsisH";
import { faRedo } from "@fortawesome/pro-regular-svg-icons/faRedo";
import { faUndo } from "@fortawesome/pro-regular-svg-icons/faUndo";
import { faEye } from "@fortawesome/pro-regular-svg-icons/faEye";
import { faUpload } from "@fortawesome/pro-regular-svg-icons/faUpload";
import { faLemon } from "@fortawesome/pro-regular-svg-icons/faLemon";
import { faCog } from "@fortawesome/pro-regular-svg-icons/faCog";
import { faMeh } from "@fortawesome/pro-regular-svg-icons/faMeh";
import { faArrowRight } from "@fortawesome/pro-regular-svg-icons/faArrowRight";
import { faArrowLeft } from "@fortawesome/pro-regular-svg-icons/faArrowLeft";
import { faSpinner as farSpinner } from "@fortawesome/pro-regular-svg-icons/faSpinner";
import { faLockAlt } from "@fortawesome/pro-regular-svg-icons/faLockAlt";
import { faGrin } from "@fortawesome/pro-regular-svg-icons/faGrin";
import { faSquare as farFaSquare } from "@fortawesome/pro-regular-svg-icons/faSquare";
import { faCheckSquare as farFaCheckSquare } from "@fortawesome/pro-regular-svg-icons/faCheckSquare";
import { faCalculator } from "@fortawesome/pro-regular-svg-icons/faCalculator";
import { faShapes } from "@fortawesome/pro-regular-svg-icons/faShapes";
import { faKey } from "@fortawesome/pro-regular-svg-icons/faKey";
import { faCalendarAlt } from "@fortawesome/pro-regular-svg-icons/faCalendarAlt";
import { faArrowDown } from "@fortawesome/pro-regular-svg-icons/faArrowDown";
import { faArrowUp } from "@fortawesome/pro-regular-svg-icons/faArrowUp";
import { faKeyboard } from "@fortawesome/pro-regular-svg-icons/faKeyboard";
import { faLock } from "@fortawesome/pro-regular-svg-icons/faLock";
import { faRocket } from "@fortawesome/pro-regular-svg-icons/faRocket";
import { faUserLock } from "@fortawesome/pro-regular-svg-icons/faUserLock";
import { faEnvelope as farFaEnvelope } from "@fortawesome/pro-regular-svg-icons/faEnvelope";
import { faGlobe as farFaGlobe } from "@fortawesome/pro-regular-svg-icons/faGlobe";
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons/faChevronRight";
import { faCheck as farFaCheck } from "@fortawesome/pro-regular-svg-icons/faCheck";
import { faText } from "@fortawesome/pro-regular-svg-icons/faText";
import { faLink as farFaLink } from "@fortawesome/pro-regular-svg-icons/faLink";
import { faMagic } from "@fortawesome/pro-regular-svg-icons/faMagic";
import { faSearch } from "@fortawesome/pro-regular-svg-icons/faSearch";
import { faCamera } from "@fortawesome/pro-regular-svg-icons/faCamera";
import { faQuestionCircle } from "@fortawesome/pro-regular-svg-icons/faQuestionCircle";
import { faLayerGroup } from "@fortawesome/pro-regular-svg-icons/faLayerGroup";
import { faGripLines } from "@fortawesome/pro-regular-svg-icons/faGripLines";
import { faExpandArrows } from "@fortawesome/pro-regular-svg-icons/faExpandArrows";
import { faChevronCircleDown } from "@fortawesome/pro-regular-svg-icons/faChevronCircleDown";
import { faAlignLeft } from "@fortawesome/pro-regular-svg-icons/faAlignLeft";
import { faAlignCenter } from "@fortawesome/pro-regular-svg-icons/faAlignCenter";
import { faAlignRight } from "@fortawesome/pro-regular-svg-icons/faAlignRight";
import { faSmile as farFaSmile } from "@fortawesome/pro-regular-svg-icons/faSmile";
import { faBold as farFaBold } from "@fortawesome/pro-regular-svg-icons/faBold";
import { faItalic as farFaItalic } from "@fortawesome/pro-regular-svg-icons/faItalic";
import { faFile } from "@fortawesome/pro-regular-svg-icons/faFile";
import { faAt } from "@fortawesome/pro-regular-svg-icons/faAt";
import { faEyeDropper } from "@fortawesome/pro-regular-svg-icons/faEyeDropper";
import { faTintSlash } from "@fortawesome/pro-regular-svg-icons/faTintSlash";
import { faPlusCircle as farPlusCircle } from "@fortawesome/pro-regular-svg-icons/faPlusCircle";
import { faPalette } from "@fortawesome/pro-regular-svg-icons/faPalette";
import { faChevronDown } from "@fortawesome/pro-regular-svg-icons/faChevronDown";
import { faHistory } from "@fortawesome/pro-regular-svg-icons/faHistory";
import { faDownload } from "@fortawesome/pro-regular-svg-icons/faDownload";
import { faTrashUndo } from "@fortawesome/pro-regular-svg-icons/faTrashUndo";
import { faToggleOff } from "@fortawesome/pro-regular-svg-icons/faToggleOff";
import { faToggleOn } from "@fortawesome/pro-regular-svg-icons/faToggleOn";
import { faShare } from "@fortawesome/pro-regular-svg-icons/faShare";
import { faUnlock } from "@fortawesome/pro-regular-svg-icons/faUnlock";
import { faTag } from "@fortawesome/pro-regular-svg-icons/faTag";
import { faPresentation } from "@fortawesome/pro-regular-svg-icons/faPresentation";
import { faExpandWide } from "@fortawesome/pro-regular-svg-icons/faExpandWide";
import { faRulerCombined } from "@fortawesome/pro-regular-svg-icons/faRulerCombined";
import { faFilePowerpoint } from "@fortawesome/pro-regular-svg-icons/faFilePowerpoint";
import { faTextSize } from "@fortawesome/pro-regular-svg-icons/faTextSize";
import { faScribble } from "@fortawesome/pro-regular-svg-icons/faScribble";
import { faFontCase } from "@fortawesome/pro-regular-svg-icons/faFontCase";
import { faTrashXmark } from "@fortawesome/pro-regular-svg-icons/faTrashXmark";
import { faDrawSquare } from "@fortawesome/pro-regular-svg-icons/faDrawSquare";
import { faFrown } from "@fortawesome/pro-regular-svg-icons/faFrown";
import { faArrowToBottom } from "@fortawesome/pro-regular-svg-icons/faArrowToBottom";
import { faHandPointUp } from "@fortawesome/pro-regular-svg-icons/faHandPointUp";
import { faRecycle } from "@fortawesome/pro-regular-svg-icons/faRecycle";

import { faGoogle } from "@fortawesome/free-brands-svg-icons/faGoogle";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons/faLinkedinIn";
import { faYoutube } from "@fortawesome/free-brands-svg-icons/faYoutube";
import { faVimeo } from "@fortawesome/free-brands-svg-icons/faVimeo";

const configureFontAwesome = () => {
  library.add(fas);
  library.add(
    faTelescope,
    faSlidersH,
    faSlidersHSquare,
    faThLarge,
    faCode,
    faLongArrowUp,
    faLongArrowDown,
    faArrowDown,
    faArrowUp,
    faLongArrowLeft,
    faLongArrowRight,
    faChartBar,
    faAward,
    faBullseyePointer,
    faPollH,
    faTimes,
    faPercent,
    faPencilAlt,
    faPencil,
    faChartScatter,
    faMapMarked,
    faAnalytics,
    faSortAlt,
    faInfoCircle,
    faHashtag,
    faDollarSign,
    faArrowsV,
    faArrowsH,
    faExclamationTriangle,
    faExclamationCircle,
    faPlug,
    faDraftingCompass,
    faPaperPlane,
    faSync,
    faTint,
    faArrowFromBottom,
    faArrowToBottom,
    faTrashAlt,
    faExternalLinkAlt,
    faPlus,
    faEllipsisH,
    faPlusCircle,
    faTable,
    faEye,
    faGoogle,
    faCopy,
    faClone,
    faSpinner,
    falSpinner,
    farSpinner,
    faRedo,
    faUndo,
    faUpload,
    faLemon,
    faCog,
    faMeh,
    faArrowRight,
    faArrowLeft,
    faLinkedinIn,
    faLockAlt,
    faSquare,
    faCheckSquare,
    faEnvelope,
    faGrin,
    farFaSquare,
    farFaCheckSquare,
    faCalculator,
    faShapes,
    faKey,
    faCalendarAlt,
    faKeyboard,
    faGlobe,
    falKey,
    faAngleDown,
    faAngleLeft,
    faAngleRight,
    faCheck,
    faLock,
    faRocket,
    faUserLock,
    farFaEnvelope,
    farFaGlobe,
    faGlassCheers,
    faLink,
    faChevronRight,
    faFrown,
    farFaCheck,
    faText,
    farFaLink,
    faMagic,
    faSearch,
    falFaChevronRight,
    faCamera,
    falTelescope,
    faSquareInfo,
    faQuestionCircle,
    faGripLines,
    faLayerGroup,
    faExpandArrows,
    faChevronCircleDown,
    falGrin,
    faLeaf,
    faHamburger,
    faHeart,
    faFutbol,
    faPlane,
    faLightbulb,
    faFlagAlt,
    faAlignLeft,
    faAlignCenter,
    faAlignRight,
    faBold,
    faItalic,
    faSmile,
    farFaBold,
    farFaItalic,
    farFaSmile,
    faQuoteLeft,
    falTimes,
    faEyeSlash,
    faFile,
    falSearch,
    faTimesCircle,
    faAt,
    faEyeDropper,
    faTintSlash,
    farPlusCircle,
    faPalette,
    faChevronDown,
    faUserEdit,
    faHistory,
    faDownload,
    faTrashUndo,
    faFileImage,
    faFilePdf,
    faChartPie,
    faToggleOff,
    faToggleOn,
    faShare,
    faUnlock,
    faTag,
    faPresentation,
    faExpandWide,
    faRulerCombined,
    faFilePowerpoint,
    faTextSize,
    faScribble,
    faFontCase,
    faTrashXmark,
    faDrawSquare,
    faYoutube,
    faVimeo,
    faHandPointUp,
    faChartColumn,
    faRecycle
  );
};

/**
 * Get all the fontawesome icons grouped by their categories.
 * If provided with a list of `styles`, only return the icons styles match any of them.
 * @param {Array} styles
 * @returns {Object} An object of the fontawesome categories with their icons.
 */
const getCategories = (styles = []) => {
  let allCategories = categories;
  if (styles.length) {
    allCategories = mapValues(allCategories, o => {
      return {
        ...o,
        icons: filter(o.icons, i => {
          const icon = icons[i];
          return icon && intersection(styles, icon.styles).length > 0;
        })
      };
    });
  }
  return allCategories;
};

const iconIsAvailable = icon => {
  return findIconDefinition({ prefix: "fa", iconName: icon }) ? true : false;
};

export { iconIsAvailable, getCategories };
export default configureFontAwesome;
